import {
  ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid,
  Tooltip, Cell, AreaChart, Area,
} from "recharts";

const BAR_COLORS = ["#6B8F7D", "#2C5446", "#CBA153", "#A67C52"];

const ChartTooltip = ({ active, payload, label, suffix }) => {
  if (!active || !payload?.length) return null;
  return (
    <div className="rounded-sm border border-gold/50 bg-ivory px-4 py-3 shadow-[0_8px_28px_rgba(26,36,32,0.15)]">
      <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-graphite/55">{label ?? payload[0].payload.anio}</p>
      <p className="mt-1 font-serif text-xl font-semibold text-jade">
        {suffix === "%"
          ? `${String(payload[0].value).replace(".", ",")}%`
          : `€${Number(payload[0].value).toLocaleString("es-ES")}`}
      </p>
    </div>
  );
};

export const RoiBarChart = ({ data }) => (
  <div data-testid="roi-bar-chart" className="rounded-sm border border-sand bg-white/85 p-5 shadow-[0_4px_24px_rgba(31,110,90,0.05)] sm:p-7">
    <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-graphite/50">
      ROI Cash anual por escenario
    </p>
    <div className="mt-4 h-64 sm:h-72">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data} margin={{ top: 10, right: 8, left: -14, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#E5DFD3" vertical={false} />
          <XAxis
            dataKey="name"
            tick={{ fill: "#1A2420", fontSize: 11, fontFamily: "Plus Jakarta Sans" }}
            axisLine={{ stroke: "#E5DFD3" }}
            tickLine={false}
          />
          <YAxis
            tick={{ fill: "#1A2420", fontSize: 11, opacity: 0.6 }}
            axisLine={false}
            tickLine={false}
            tickFormatter={(v) => `${v}%`}
          />
          <Tooltip cursor={{ fill: "rgba(200,169,106,0.08)" }} content={<ChartTooltip suffix="%" />} />
          <Bar dataKey="roi" radius={[3, 3, 0, 0]} maxBarSize={64}>
            {data.map((_, i) => (
              <Cell key={i} fill={BAR_COLORS[i % BAR_COLORS.length]} />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  </div>
);

export const AppreciationChart = ({ data }) => (
  <div data-testid="appreciation-chart" className="rounded-sm border border-sand bg-white/85 p-5 shadow-[0_4px_24px_rgba(31,110,90,0.05)] sm:p-7">
    <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-graphite/50">
      Proyección de valor del inmueble · 10 años
    </p>
    <div className="mt-4 h-64 sm:h-80">
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart data={data} margin={{ top: 10, right: 8, left: 0, bottom: 0 }}>
          <defs>
            <linearGradient id="jadeFill" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#2C5446" stopOpacity={0.28} />
              <stop offset="100%" stopColor="#2C5446" stopOpacity={0.02} />
            </linearGradient>
          </defs>
          <CartesianGrid strokeDasharray="3 3" stroke="#E5DFD3" vertical={false} />
          <XAxis
            dataKey="anio"
            tick={{ fill: "#1A2420", fontSize: 11 }}
            axisLine={{ stroke: "#E5DFD3" }}
            tickLine={false}
            tickFormatter={(v) => `Año ${v}`}
          />
          <YAxis
            tick={{ fill: "#1A2420", fontSize: 10, opacity: 0.6 }}
            axisLine={false}
            tickLine={false}
            width={64}
            tickFormatter={(v) => `€${Math.round(v / 1000)}k`}
          />
          <Tooltip content={<ChartTooltip />} />
          <Area
            type="monotone"
            dataKey="valor"
            stroke="#CBA153"
            strokeWidth={2.5}
            fill="url(#jadeFill)"
            dot={{ r: 3, fill: "#2C5446", strokeWidth: 0 }}
            activeDot={{ r: 5, fill: "#CBA153", stroke: "#2C5446", strokeWidth: 2 }}
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  </div>
);
